<template style="">
  <div class="Picture_release" v-loading="loading" element-loading-text="上传中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <el-form label-width="80px" style="padding-top: 20px;" :model="ValidateForm" ref="ValidateForm">
      <el-form-item label="文章标题" prop="MaterialName" :rules="[{ required: true, message: '请输入文章标题', trigger: 'blur' }]">
        <el-input style="width: 300px;" v-model="ValidateForm.MaterialName" placeholder="请输入文章标题（5-30个汉字）" maxlength="30" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="上传封面" style="height: 180px;" :rules="[{ required: true, message: '请选择上传文件', trigger: 'change' }]">
        <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"  accept=".jpg, .jpeg, .png">
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon">
            <span style="font-size: 16px;">点击选择文件</span>
          </i>
        </el-upload>

        <p style="margin-left: 240px;color: #606266;">请发布与网站主题相关的图片，图片大小需控制在500K以内 文件格式请用.jpg .png .jpeg  图片尺寸建议：2.35:1</p>

      </el-form-item>

      <el-form-item label="栏目" :rules="[{ required: true, message:'请选择栏目', trigger: 'change' }]">
        <!-- <el-cascader 
        ref="wcascader" 
        v-model="ItemKey" 
        @change="Selected_to_shut_dow" 
        @expand-change="bumen" 
        :options="data" 
        :props="{ checkStrictly: true }" 
        clearable 
        placeholder="请选择上级栏目"></el-cascader> -->

        <el-select v-model="ItemKey" placeholder="请选择栏目">
          <el-option v-for="(item,index) in columnList" :key="index" :label="item.value" :value="item.key"></el-option>
        </el-select>

      </el-form-item>

      <el-form-item label="标签">
        <el-checkbox-group v-model="Label">
          <el-checkbox v-for="item in tagList" :key="item.key" :label="item.key">{{ item.value }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>


      <el-form-item label="定时发送">
        <el-radio-group v-model="timisngs">
          <el-radio label="1">否</el-radio>
          <el-radio label="2">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="timisngs == '2'" label="定时时间">
        <el-date-picker  v-model="ScheduledRelease" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"  type="datetime" placeholder="选择日期时间" :picker-options="pickerOptions" @change="handleDateTimeChange">
          </el-date-picker>
      </el-form-item>

      <el-form-item label="用途">
        <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="Purpose" maxlength="100" show-word-limit></el-input>
      </el-form-item>

      <el-form-item label="排序">
        <el-input :rows="2" placeholder="请输入内容" type="number" v-model="LineNumber"  maxlength="3" show-word-limit></el-input>
      </el-form-item>

      <!-- <el-form-item label="是否启用">
        <el-switch v-model="isActive" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item> -->

      <el-form-item label="版权声明">
        <el-input type="textarea" :rows="2" placeholder="请输入内容" maxlength="200" show-word-limit v-model="CopyrightStatement"></el-input>
      </el-form-item>

      <el-form-item class="ue" props="Articlecontent" label="内容" :rules="[{ required: true, message: '请输入文章内容', trigger: 'blur' },{required: true, message: '请输入文章内容', trigger: 'change'}]">

        <div class="editor-container">
          <UEtext :defaultMsg=defaultMsg ref="ue"></UEtext>
        </div>
      </el-form-item>

      <el-form-item label="审核意见" v-if="state==1">
        <el-radio-group v-model="AuditStatus">
          <el-radio label="1">通过</el-radio>
          <el-radio label="2">驳回</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="AuditStatus==2 && state==1" label="驳回原因">
        <el-input type="textarea" v-model="ReasonRejection" :autosize="{ minRows: 2}"></el-input>
      </el-form-item>

      <el-form-item style="padding-bottom: 30px;" v-if="state==1">
        <el-button type="primary" :loading="iscontinuous" @click="onSubmit(1)">保存</el-button>
      </el-form-item>

      <el-form-item style="padding-bottom: 30px;" v-else>
        <el-button type="primary" :loading="iscontinuous" @click="onSubmit(1)">{{materialKey?'立即修改':'立即创建'}}</el-button>
        <!-- <el-button type="primary" v-if="!materialKey" :loading="iscontinuous" @click="onSubmit(2)">保存草稿</el-button> -->
      </el-form-item>
      
    </el-form>

    <el-dialog title="图片裁剪" :visible.sync="Croppdialog" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="closeCroppdialog" width="640px">

      <PictureCropper ref="picture" :initialImg="imageUrl" :cropperHeight="cropperHeight" :cropperWidth="cropperWidth" :autoCropWidth="autoCropWidth" :autoCropHeight="autoCropHeight" @picturePreview="picturePreview" />

      <span slot="footer" class="dialog-footer">
        <el-button @click="Croppdialog=false;">取 消</el-button>
        <el-button type="primary" @click="closeCroppdialog(2)">确 定</el-button>
      </span>

    </el-dialog>
    
  </div>
</template>
<script>
import UEtext from '@/components/text.vue';
import PictureCropper from '@/components/pictureCropper.vue'
export default {
  components: { UEtext,PictureCropper},
  data() {
    return { 
      timisngs:'1',
      ScheduledRelease:'',

      iscontinuous:false,
      RoleID:sessionStorage.getItem('RoleID'),
      Purpose: '',
      LineNumber: '',
      CopyrightStatement: '',
      data: [],
      loading:false,
      videopd:false,
      videourl: '',
      videoFile:"",//视频文件
      imageFile:"",//图片文件
      ValidateForm:{
        MaterialName: "",//视频标题
        Articlecontent:'',
      },
      Label: [],//标签
      ItemKey: "1",//栏目
      img: "",
      imageUrl: '',
      tagList:[],//标签列表
      columnList: [],//栏目列表
      defaultMsg: '',
      materialKey: '',
      isActive:1,
      state:0,
      AuditStatus:'',
      ReasonRejection:'',

      // 裁剪
      Croppdialog:false,
      previews: {},
      cropperHeight: '600px',  // 裁剪图片容器高度
      cropperWidth: '600px',   // 裁剪图片容器宽度
      autoCropWidth: 200,
      autoCropHeight: 200,
      editor: null,
      defaultMsg: '',
      config: {
        // 禁用有问题的组件
        elementPathEnabled: false,
        wordCount: false,
        enableContextMenu: false,
        // 配置服务器路径
        serverUrl: '', // 留空，使用默认配置
        // 禁用 ZeroClipboard，使用原生剪贴板
        enableAutoSave: false,
        // 自定义配置，避免请求默认配置文件
        autoHeightEnabled: false,
        initialFrameHeight: 400,
        initialFrameWidth: '100%'
      }, 
    }
  },
  mounted() {
    this.initEditor();
    this.checkAndLoadScripts();
    this.getTagList();
    this.getcolumnList();
    this.getColumnManagementByNode();
    this.materialKey = this.$route.query.materialKey;
    if(this.materialKey){
      this.state=this.$route.query.type;
      this.getContentDetails();
    }
  },
   // ==== 新增计算属性 ====
   computed: {
    pickerOptions() {
      return {
        disabledDate: (time) => {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        },
        selectableRange: this.getSelectableRange(),
        // onPick: ({ date }) => {
        //   if (date) {
        //     this.$nextTick(() => {
        //       this.handleDateSelection(date);
        //     });
        //   }
        // }
      };
    }
  },
  methods: {
    // ==== 新增：日期选择处理 ====
    handleDateSelection(date) {
      const now = new Date();
      const selected = new Date(date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      selected.setHours(0, 0, 0, 0);
      
      let newDateTime;
      
      if (selected.getTime() === today.getTime()) {
        // 选择今天，直接使用当前时间
        newDateTime = new Date();
      } else {
        // 选择未来日期，设置为上午9点
        newDateTime = new Date(date);
        newDateTime.setHours(9, 0, 0, 0);
      }
      
      this.ScheduledRelease = newDateTime;
    },

    // ==== 新增：获取可选择的时间范围 ====
    getSelectableRange() {
      const now = new Date();
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (!this.ScheduledRelease || this.timisngs !== '2') {
        return ['00:00:00 - 23:59:59'];
      }
      
      try {
        const selectedDate = new Date(this.ScheduledRelease);
        const selectedDay = new Date(selectedDate);
        selectedDay.setHours(0, 0, 0, 0);
        
        if (selectedDay.getTime() === today.getTime()) {
          const currentHour = now.getHours();
          const currentMinute = now.getMinutes();
          
          let startHour = currentHour;
          let startMinute = currentMinute;
          
          const startTime = `${startHour.toString().padStart(2, '0')}:${startMinute.toString().padStart(2, '0')}:00`;
          return [`${startTime} - 23:59:59`];
        }
      } catch (error) {
        console.warn('日期解析错误:', error);
      }
      
      return ['00:00:00 - 23:59:59'];
    },
    // ==== 新增：日期时间变化处理（重要！）====
    handleDateTimeChange(value) {
      // 当用户手动选择时间时，确保时间有效性
      if (value && this.timisngs === '2') {
        const selectedDate = new Date(value);
        const now = new Date();
        
        // 检查选择的日期是否是今天
        const selectedDay = new Date(selectedDate);
        selectedDay.setHours(0, 0, 0, 0);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        // 只有当选择的是今天，并且时间早于当前时间时才进行调整
        if (selectedDay.getTime() === today.getTime() && selectedDate.getTime() < now.getTime()) {
          const adjustedDate = new Date();
          this.ScheduledRelease = adjustedDate;
        }
      }
    },
    checkAndLoadScripts() {
      // 检查并动态加载缺失的脚本
      if (typeof CodeMirror === 'undefined') {
        this.loadScript('/static/codemirror/codemirror.js').then(() => {
          console.log('CodeMirror loaded successfully');
        }).catch(error => {
          console.error('Failed to load CodeMirror:', error);
        });
      }
      
      if (typeof ZeroClipboard === 'undefined') {
        this.loadScript('/static/ZeroClipboard/ZeroClipboard.js').then(() => {
          console.log('ZeroClipboard loaded successfully');
        }).catch(error => {
          console.error('Failed to load ZeroClipboard:', error);
        });
      }
    },
    
    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },

    getTagList(){
      this.$Http_Post('management/tagList',).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tagList = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },

    getcolumnList(){
      this.$Http_Post('management/columnList',).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.columnList = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },

    getColumnManagementByNode(){
      this.$Http_Post('management/getColumnManagementByNode', { PItemKey: '0', pageIndex: "1", pageSize: "111110", Type: 1,RoleID:this.RoleID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.data = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },

    // 获取详情
    getContentDetails(){
      this.$Http_Post('management/getContentDetails', { MaterialKey: this.materialKey }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.imageUrl = res.Data.materialCover;
          this.ValidateForm.MaterialName = res.Data.materialName;
          this.Label = res.Data.labeles;
          this.ItemKey = res.Data.itemKey.toString();
          this.Purpose=res.Data.purpose;
          this.LineNumber=res.Data.lineNumber;
          this.isActive=res.Data.isActive;
          this.CopyrightStatement=res.Data.copyrightStatement;
          if(res.Data.scheduledRelease){
            this.timisngs = '2';
            this.ScheduledRelease = res.Data.scheduledRelease;
          }
          this.$nextTick(()=>{
            this.defaultMsg = res.Data.richTextContent;
          })
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },

    picturePreview(data){
      this.previews = data
    },
    Selected_to_shut_dow(dt) {
      this.ItemKey = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },

    async download(){
      let aLink = document.createElement('a')
      aLink.download = '下载裁剪图片'
      let data = await this.$refs.picture.getBase64()
      aLink.href = data
      aLink.click()
    },

    // 确认裁剪并关闭弹窗
    async closeCroppdialog(e){
      this.Croppdialog=false;
      if(e==2){//确认裁剪并关闭
        this.imageUrl=await this.$refs.picture.getBase64();
        this.imageFile=await this.$refs.picture.getfile(this.imageUrl,Math.floor(new Date().getTime())+'.png');
      }
    },

    GetNodeByDeptID(ID, NodeList) {
      let obj = null
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].value == ID) {
          obj = NodeList[i]
          break
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].value != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children)
          if (obj != null) break
        }
      }
      return obj
    },

    bumen(dt) {
      let obj = this.data[0];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].value == dt[dt.length - 1]) {
          obj = this.data[i];
        } else if (this.data[i].fuzi && this.data[i].children.length > 0 && this.data[i].children[0].value != '-1') {
          obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
        }
      }
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].value == '-2') {
        obj.children = [{ label: this.$t('original.languages22') }]
        this.$Http_Post('/management/getColumnManagementByNode', { PItemKey: dt[dt.length - 1], pageIndex: "1", pageSize: "111110", Type: 1,RoleID:this.RoleID}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        })
      }
    },

    onSubmit(type) {//创建
      this.Articlecontent=this.$refs.ue.getUEContent();
      this.$refs['ValidateForm'].validate((valid) => {
          if (valid && this.Articlecontent!='') {
            this.iscontinuous = true
            this.loading = true;
            var from = new FormData();
            if(this.materialKey){//修改
              from.append('MaterialKey', this.materialKey);
              from.append('RoleID',sessionStorage.getItem('RoleID'));
            }
            if(this.state==1){
              from.append('AuditStatus', this.AuditStatus);
              if(this.AuditStatus==2){
                from.append('ReasonRejection', this.ReasonRejection);
              }
            }

            from.append('fileName', this.imageFile==""?"":this.imageFile);
            from.append('MaterialName', this.ValidateForm.MaterialName);
            from.append('Label', this.Label);
            from.append('ItemKey', this.ItemKey);
            from.append('Type', type);
            from.append('Purpose', this.Purpose);
            from.append('LineNumber', this.LineNumber);
            from.append('IsActive', this.isActive);
            from.append('CopyrightStatement', this.CopyrightStatement);
            from.append('CodeSnippet',this.$refs.ue.getUEContent());
            from.append('ScheduledRelease', this.ScheduledRelease);
            this.$Http_Post('management/articlePublishing', from, { 'Content-Type': 'multipart/form-data', }).then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.iscontinuous = false
                this.loading = false;
                this.Global.request_successful(res.Message);
                this.$router.push({path:this.state==1 || this.state==2?'/propagate/Content_review':'/propagate/index'})
              } else {
                this.iscontinuous = false
                this.loading = false;
                this.Global.request_failure(res.Message);
              }
            })
          } else {
            this.Global.request_failure("请填写完整信息");
            return false;
          }
        });
      
    },
    handleChange(file, fileList) {
      if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/gif' || file.raw.type == 'image/png') {
        this.imageUrl = URL.createObjectURL(file.raw);  
        this.imageFile = file;
        this.Croppdialog = true;
      } else {
        this.$message({ type: 'error', message: '文件格式错误，请上传图片' })
      }
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 8
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },

    initEditor() {
      // 确保 UEditor 资源正确加载
      if (typeof UE !== 'undefined') {
        try {
          // 删除有问题的依赖检查
          this.fixUEditorDependencies();
          
          this.editor = UE.getEditor('editor', this.config);
          
          this.editor.ready(() => {
            console.log('UEditor ready');
            this.fixEditorConfig();
          });
          
          // 错误处理
          this.editor.addListener('error', (error) => {
            console.warn('UEditor error:', error);
            this.handleUEditorError(error);
          });
          
        } catch (error) {
          console.error('UEditor init error:', error);
          this.fallbackEditor();
        }
      } else {
        console.error('UEditor not loaded, retrying...');
        setTimeout(() => this.initEditor(), 500);
      }
    },
    
    fixUEditorDependencies() {
      // 修复 ZeroClipboard 问题
      if (typeof ZeroClipboard === 'undefined') {
        console.warn('ZeroClipboard not available, using fallback');
        // 创建一个假的 ZeroClipboard 对象来避免错误
        window.ZeroClipboard = {
          config: function() { return this; },
          on: function() { return this; },
          emit: function() { return this; },
          create: function() { return this; },
          destroy: function() { return this; }
        };
      }
      
      // 修复 CodeMirror 问题
      if (typeof CodeMirror === 'undefined') {
        console.warn('CodeMirror not available, using fallback');
        window.CodeMirror = function() {
          return {
            setValue: function() {},
            getValue: function() { return ''; },
            on: function() {}
          };
        };
      }
    },
    
    fixEditorConfig() {
      // 修复上传配置
      try {
        // 设置自定义上传配置，避免请求默认配置
        this.editor.setOpt({
          // 图片上传配置
          imageFieldName: "upfile",
          imageUrl: "/api/upload/image", // 根据你的后端接口调整
          imageMaxSize: 500 * 1024, // 500K
          imageAllowFiles: [".png", ".jpg", ".jpeg", ".gif", ".bmp"],
          
          // 文件上传配置
          fileFieldName: "upfile",
          fileUrl: "/api/upload/file",
          fileMaxSize: 10 * 1024 * 1024,
          fileAllowFiles: [
            ".png", ".jpg", ".jpeg", ".gif", ".bmp",
            ".flv", ".swf", ".mkv", ".avi", ".rm", ".rmvb", ".mpeg", ".mpg",
            ".ogg", ".ogv", ".mov", ".wmv", ".mp4", ".webm", ".mp3", ".wav", ".mid",
            ".rar", ".zip", ".tar", ".gz", ".7z", ".bz2", ".cab", ".iso",
            ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".pdf", ".txt", ".md"
          ]
        });
        
        console.log('UEditor config fixed');
      } catch (error) {
        console.error('Error fixing editor config:', error);
      }
    },
    
    handleUEditorError(error) {
      // 处理特定错误
      if (error.toString().includes('ZeroClipboard')) {
        console.warn('ZeroClipboard error suppressed');
        return true; // 阻止默认错误处理
      }
      if (error.toString().includes('后台配置项')) {
        console.warn('UEditor config request error suppressed');
        return true; // 阻止默认错误处理
      }
      return false;
    },
    
    fallbackEditor() {
      // 如果 UEditor 完全失败，使用简单的 textarea 作为回退
      console.warn('Using fallback editor');
      const container = document.getElementById('editor');
      if (container) {
        container.innerHTML = `
          <textarea 
            style="width:100%; height:400px; border:1px solid #ccc; padding:10px;" 
            placeholder="富文本编辑器加载失败，使用简易编辑器"
            v-model="content"
          ></textarea>
        `;
      }
    },
    
    getUEContent() {
      if (this.editor && this.editor.isReady) {
        return this.editor.getContent();
      }
      // 回退方案
      const textarea = document.querySelector('#editor textarea');
      return textarea ? textarea.value : this.defaultMsg;
    },
    
    setUEContent(content) {
      if (this.editor && this.editor.isReady) {
        this.editor.setContent(content);
      }
      // 回退方案
      const textarea = document.querySelector('#editor textarea');
      if (textarea) {
        textarea.value = content;
      } else {
        this.defaultMsg = content;
      }
    },
  
    beforeDestroy() {
      // 安全销毁编辑器
      if (this.editor && this.editor.destroy) {
        try {
          this.editor.destroy();
        } catch (error) {
          console.warn('Error destroying editor:', error);
        }
      }
    }

  },
}
</script>
<style>
  .Picture_release{background-color: #fff;width: 100%;}
  .avatar-uploader .el-upload:hover {border-color: #409eff;}
  .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
  .avatar {width: 215px;height: 148px;display: block;}
  .cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 175px;}
  .avatar-uploader {position: absolute;top: 0px;left: 0px;}
  .cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 330px;width: 350px;}
  .scale {margin-top: 30px;max-height: 333px;overflow: overlay;}
  .scale,.scale0 {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;max-height: 333px;overflow: overlay;}
  .Picture_release .el-textarea{width: 400px !important;}
  .Picture_release .el-input{width: 400px !important;}
  .editor-container{width: 750px;display: block;}
  .ue .el-form-item__content{line-height:1;}
  
</style>
